export const Payment = ["Once off", "Monthly"];
